import { FeeType, PaymentMethodType, PricingSpec, PricingSpecRequest } from '@nemuru-eng/js-api-client';

import { ProductSelectOption } from '@/components/modules/PricingCreate/types/ProductSelectOption';
import { ProgramSelectOption } from '@/components/modules/PricingCreate/types/ProgramSelectOption';
import { optionalStringToNumberMap } from '@/utils/zodUtils';

import { PricingSpecFormValues } from '../types/PricingSpecFormValues';

export class PricingSpecRequestMap {
  public static fromFormValues(
    id: string,
    product: ProductSelectOption,
    program: ProgramSelectOption,
    paymentMethodType: PaymentMethodType,
    data: PricingSpecFormValues,
  ): PricingSpecRequest {
    return {
      id,
      product,
      program,
      paymentMethodType,
      rangePrincipalMin: Number(data.minPrincipal) as number,
      rangePrincipalMax: Number(data.maxPrincipal) as number,
      rangePeriodMin: data.minTerm,
      rangePeriodMax: data.maxTerm,
      merchantDiscountPercentage: (data.merchantDiscountPercentage ? Number(data.merchantDiscountPercentage) : 0) / 100,
      merchantFeeType: data.merchantFeeType ?? FeeType.PERCENTAGE,
      merchantFeeValue:
        data.merchantFeeValue !== undefined
          ? data.merchantFeeType === FeeType.FIX_AMOUNT
            ? Number(data.merchantFeeValue)
            : Number(data.merchantFeeValue) / 100
          : 0,
      interest: data.annualInterest !== undefined ? Number(data.annualInterest) / 100 : 0,
      setupFeePaymentType: data.setupFeePaymentType,
      setupFeeType: data.setupFeeType,
      setupFeeValue:
        data.setupFeeType === FeeType.FIX_AMOUNT ? Number(data.setupFeeValue) : (data.setupFeeValue ?? 0) / 100,
      gracePeriod: data.gracePeriod !== undefined ? Number(data.gracePeriod) : 0,
      gracePercentage: data.gracePercentage !== undefined ? Number(data.gracePercentage) / 100 : 0,
      yearsSinceAutoRegistrationMin: optionalStringToNumberMap(data.yearsSinceAutoRegistrationMin),
      yearsSinceAutoRegistrationMax: optionalStringToNumberMap(data.yearsSinceAutoRegistrationMax),
      // isNew: z.boolean().optional(),
      riskScoring: null,
    };
  }

  public static fromPricingSpec(pricingSpec: PricingSpec): PricingSpecRequest {
    return {
      id: pricingSpec.id,
      rangePrincipalMin: pricingSpec.rangePrincipalMin,
      rangePrincipalMax: pricingSpec.rangePrincipalMax,
      product: pricingSpec.product,
      program: pricingSpec.program,
      rangePeriodMin: pricingSpec.rangePeriodMin,
      rangePeriodMax: pricingSpec.rangePeriodMax,
      merchantDiscountPercentage: pricingSpec.merchantDiscountPercentage ?? undefined,
      interest: pricingSpec.interest,
      setupFeePaymentType: pricingSpec.setupFee?.paymentType,
      setupFeeType: pricingSpec.setupFee?.type,
      setupFeeValue: pricingSpec.setupFee?.value,
      gracePeriod: pricingSpec.gracePeriod ?? undefined,
      gracePercentage: pricingSpec.gracePercentage ?? undefined,
      yearsSinceAutoRegistrationMin: pricingSpec.yearsSinceAutoRegistrationMin,
      yearsSinceAutoRegistrationMax: pricingSpec.yearsSinceAutoRegistrationMax,
      paymentMethodType: pricingSpec.paymentMethodType,
      // isNew: z.boolean().optional(),
      riskScoring: null,
    };
  }
}
